export class ComplexMapping {
    constructor() {
        this.modal = null;
        this.mappingModal = null;
        this.init();
    }

    init() {
        this.modal = document.getElementById("mapping-modal");
        if (!this.modal) return;

        this.mappingModal = new bootstrap.Modal(this.modal, {});
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('click', (e) => {
            const target = e.target.closest('[data-mapping-url]');
            if (!target) return;

            e.preventDefault();
            this.handleMappingClick(target);
        });
    }

    handleMappingClick(element) {
        const url = element.getAttribute('data-mapping-url');
        this.removeTooltips();

        const mappingWrap = document.getElementById('mapping-wrap');
        if (mappingWrap) {
            window.addFullLoader(mappingWrap);
        }

        this.makeRequest(url);
    }

    async makeRequest(url) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.processResponse(data);

        } catch (error) {
            console.error('Request failed:', error);
            this.handleError(error);
        }
    }

    processResponse(data) {
        if (data.html !== undefined) {
            const mappingWrap = document.getElementById('mapping-wrap');
            if (mappingWrap) {
                mappingWrap.innerHTML = data.html;
            }
        }

        if (data.modal !== undefined) {
            this.showModal(data);
        }

        if (window.initTooltips) {
            window.initTooltips();
        }

        if (window.removeLoader) {
            window.removeLoader();
        }
    }

    showModal(data) {
        const modalBody = this.modal.querySelector('.modal-body');
        if (modalBody) {
            modalBody.innerHTML = data.modal;
        }

        const infoLink = document.getElementById('mapping-modal-more-info');
        if (infoLink) {
            if (data.moreinfo !== undefined) {
                infoLink.classList.remove('hidden', 'd-none');
                infoLink.setAttribute('href', data.moreinfo);
            } else {
                infoLink.classList.add('hidden', 'd-none');
            }
        }

        this.mappingModal.show();
    }

    removeTooltips() {
        const tooltips = document.querySelectorAll('.tooltip');
        tooltips.forEach(tooltip => tooltip.remove());
    }

    handleError(error) {
        console.error('ComplexMapping error:', error);
        if (window.removeLoader) {
            window.removeLoader();
        }
        // Add any additional error handling here
    }

    // Public method to destroy the instance
    destroy() {
        // Remove event listeners if needed
        // Clean up resources
        this.modal = null;
        this.mappingModal = null;
    }
}